var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.933 16.933",
    id: "DocFile",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.968,
    transform: "matrix(1.03366 0 0 1.03333 -2.911 3.935)",
    fill: "#437ef7",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.9217235,-3.8085938 A 0.25603411,0.25603411 0 0 0 4.6658641,-3.5527344 V 12.322266 a 0.25603411,0.25603411 0 0 0 0.2558594,0.255859 H 17.093598 a 0.25603411,0.25603411 0 0 0 0.255859,-0.255859 V 1.3886719 a 0.25603411,0.25603411 0 0 0 -0.07227,-0.1796875 l -4.796875,-4.9179688 v -0.00195 a 0.25600851,0.25600851 0 0 0 -0.01953,-0.019531 0.25600851,0.25600851 0 0 0 -0.02149,-0.019531 0.25600851,0.25600851 0 0 0 -0.02344,-0.017578 0.25600851,0.25600851 0 0 0 -0.02344,-0.013672 0.25600851,0.25600851 0 0 0 -0.01367,-0.00586 0.25600851,0.25600851 0 0 0 -0.02539,-0.00977 0.25600851,0.25600851 0 0 0 -0.01367,-0.00391 0.25600851,0.25600851 0 0 0 -0.0059,0 0.25600851,0.25600851 0 0 0 -0.03711,-0.00586 0.25600851,0.25600851 0 0 0 -0.01367,-0.00195 0.25600851,0.25600851 0 0 0 -0.0059,0 h -0.0078 z m 0.2558594,0.5117188 h 6.9902341 l 4.669922,4.7890625 V 12.066406 H 5.1775829 Z",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    opacity: 0.99,
    overflow: "visible",
    fill: "#437ef7",
    className: "color000000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.269531 -3.8085938 A 0.25603411 0.25603411 0 0 0 12.021484 -3.5527344 L 12.021484 1.3886719 A 0.25603411 0.25603411 0 0 0 12.277344 1.6445312 L 17.09375 1.6445312 A 0.25603411 0.25603411 0 0 0 17.277344 1.2089844 L 12.460938 -3.7304688 A 0.25603411 0.25603411 0 0 0 12.269531 -3.8085938 z M 12.533203 -2.921875 L 16.488281 1.1328125 L 12.533203 1.1328125 L 12.533203 -2.921875 z ",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    opacity: 0.99,
    overflow: "visible",
    fill: "#437ef7",
    className: "color000000 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      lineHeight: 2,
      InkscapeFontSpecification: "Calibri",
      textAlign: "center"
    },
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.265,
    "aria-label": "DOC",
    fontFamily: "Calibri",
    fontSize: 5.292,
    opacity: 0.99,
    textAnchor: "middle",
    className: "colorStroke000000 svgStroke"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#437ef7",
    stroke: "none",
    d: "M6.5417184 13.443623q0 .434083-.1111044.759644Q6.3195096 14.526245 6.1050523 14.740703 5.8931788 14.952576 5.58312 15.058513 5.2730612 15.16445 4.8441465 15.16445H4.136179q-.059428 0-.1136882-.03876-.051677-.04134-.051677-.14211V12.00185q0-.100769.051677-.139526.05426-.04134.1136882-.04134h.7570602q.4340823 0 .7338058.113688.2997235.111104.5012617.322978.204122.209289.3074749.509013.1059368.299723.1059368.676961zm-.467672.01809q0-.271301-.067179-.503845Q5.9396876 12.722737 5.7949935 12.552204 5.6528832 12.381672 5.4332582 12.286071 5.2136333 12.190469 4.867401 12.190469H4.4152319v2.60191h.4573367q.3203941 0 .540019-.0801.219625-.0801.3669029-.245464.147278-.165364.219625-.413411.074931-.250631.074931-.591696zM10.027296 13.453959q0 .40566-.095602.731222-.095601.325561-.2868044.555522-.188619.227376-.4754234.3514-.2868044.121439-.6692102.121439-.3772382 0-.6537073-.111104Q7.5726638 14.98875 7.3917961 14.774292 7.2135123 14.559835 7.1256624 14.242025q-.08785-.31781-.08785-.731222 0-.395325.095601-.718303.095602-.322978.2868044-.54777.1912029-.227377.4780073-.348817.2868044-.124023.6692102-.124023.3694867 0 .643372.111104.2738852.111105.4547528.325562.1834515.211873.2713015.5271.090434.312643.090434.718303zm-.4676722.03101q0-.284221-.051677-.5271Q9.4588547 12.712402 9.3399988 12.534118 9.2237268 12.35325 9.0273562 12.252481 8.8309856 12.151712 8.5415975 12.151712q-.2893882 0-.4857588.10852-.1963706.108521-.3203941.289389-.1214397.180867-.1757.423747-.051676.240295-.051676.506429 0 .294556.049093.542603.049093.248047.1653647.428914.1162721.178284.3100588.279053.1963705.09819.4909264.09819.291972 0 .4909264-.108521.1989544-.10852.3203941-.291972.1214397-.186035.1731161-.428915.051677-.242879.051677-.51418zM12.962519 14.69161q0 .04134-.0026.07235-.0026.03101-.01033.05426-.0052.02325-.0155.04134-.01034.01809-.03617.04392-.02584.02584-.10852.0801-.08268.05168-.206706.103353-.12144.04909-.281637.08268-.157613.03617-.346232.03617-.325562 0-.589112-.108521-.260966-.10852-.447001-.320394-.183452-.211873-.284221-.521932-.09819-.312643-.09819-.718303 0-.415995.105936-.741557.108521-.325562.302308-.550354.193787-.227377.462504-.346233.271302-.118856.599447-.118856.144694 0 .281637.02842.136942.02584.253215.06718.116272.04134.206705.0956.09043.05426.124024.09043.03617.03359.04651.05168.01033.01809.0155.04392.0078.02325.01034.05684.0052.03359.0052.0801 0 .05168-.0052.08785-.0052.03617-.0155.06201-.01033.02325-.02584.03617-.01292.01034-.03359.01034-.03617 0-.100769-.04909-.0646-.05168-.167949-.111104-.100769-.06201-.248047-.111105-.144694-.05168-.348816-.05168-.222208 0-.40566.09043-.180868.08785-.310059.260966-.129191.173116-.201538.423747-.06976.248047-.06976.568441 0 .31781.06718.563273.06976.24288.196371.408244.129191.162781.315226.248047.186036.08268.421163.08268.198955 0 .346233-.04909.149861-.04909.253214-.10852.105937-.06201.173117-.111105.06718-.04909.105936-.04909.01809 0 .03101.0078.01292.0078.02067.03101.0078.02067.01033.05943.0052.03876.0052.09819z",
    fontWeight: 400,
    className: "color000000 svgShape"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.fc5ed215671fa28d8c68406a29e0df39.svg";
export { ForwardRef as ReactComponent };